import { lazy } from 'react';
import { RouteObject, Navigate } from 'react-router-dom';
import MainLayout from '../layouts/MainLayout';
import ProjectLayout from '../layouts/ProjectLayout';
const LauncherPage = lazy(() => import('../pages/launcher/LauncherPage'));
import MobileLayout from '../layouts/MobileLayout';
import PrivateRoute from '../components/PrivateRoute';
const RootRedirect = lazy(() => import('../components/RootRedirect'));

const Landing = lazy(() => import('../pages/landing/page'));
const Obras = lazy(() => import('../pages/obras/page'));
const Login = lazy(() => import('../pages/login/page'));
const Cadastro = lazy(() => import('../pages/cadastro/page'));
const VerifyEmailPage = lazy(() => import('../pages/verify-email/page'));
const Orcamento = lazy(() => import('../pages/orcamento/page'));
const Cronograma = lazy(() => import('../pages/cronograma/page'));
const RdoPage = lazy(() => import('../pages/rdo/page'));
const Timeline = lazy(() => import('../pages/timeline/page'));
const Financeiro = lazy(() => import('../pages/financeiro/page'));
const ObraFinanceiro = lazy(() => import('../pages/obra-financeiro/page'));
const EstoquePage = lazy(() => import('../pages/estoque/page'));
const LogisticaPage = lazy(() => import('../pages/logistica/page'));
const RecebimentoPage = lazy(() => import('../pages/logistica/recebimento/index')); // Corrected path to directory index
const RequisicoesPage = lazy(() => import('../pages/obras/requisicoes/page'));
const EquipamentosPage = lazy(() => import('../pages/equipamentos/index'));
const MachineDetails = lazy(() => import('../pages/equipamentos/components/MachineDetails'));
const PcmConstrutorPage = lazy(() => import('../pages/pcm-construtor/page'));
const PcmTecnicoPage = lazy(() => import('../pages/pcm-tecnico/page'));
const PcmDashboardPage = lazy(() => import('../pages/pcm-dashboard/page'));
const PcmOperadorScanPage = lazy(() => import('../pages/pcm-operador-scan/page'));
const PcmOperadorPanicPage = lazy(() => import('../pages/pcm-operador-panic/page'));
const PcmOperadorAtivoPage = lazy(() => import('../pages/pcm-operador/OperadorAtivo'));
const PcmOperadorPage = lazy(() => import('../pages/pcm-operador/page'));
const PcmTecnicoScanPage = lazy(() => import('../pages/pcm-tecnico-scan/page'));
const PcmTecnicoCheckinPage = lazy(() => import('../pages/pcm-tecnico-checkin/page'));
const PcmTecnicoHomePage = lazy(() => import('../pages/pcm-tecnico/Home'));
const AgendaPage = lazy(() => import('../pages/agenda/page'));
const IntelligenceDashboard = lazy(() => import('../pages/analytics/IntelligenceDashboard'));
const TermsPage = lazy(() => import('../pages/legal/TermsPage'));
const PrivacyPage = lazy(() => import('../pages/legal/PrivacyPage'));

// SuprimentosPage removed

const SettingsPage = lazy(() => import('../pages/configuracoes/page'));
const TstDashboard = lazy(() => import('../pages/tst/Dashboard'));
const OsRedirect = lazy(() => import('../pages/pcm-dashboard/OsRedirect'));
const VouchersPage = lazy(() => import('../pages/master/VouchersPage'));
const MasterDashboard = lazy(() => import('../pages/master/MasterDashboard'));
const UpgradePage = lazy(() => import('../pages/assinatura/UpgradePage'));
const GlobalRolesPage = lazy(() => import('../pages/master/GlobalRolesPage'));
const GlobalChecklistsPage = lazy(() => import('../pages/master/GlobalChecklistsPage'));
const GlobalNrsPage = lazy(() => import('../pages/master/GlobalNrsPage'));
const GlobalPanicPage = lazy(() => import('../pages/master/GlobalPanicPage'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/login',
    element: <Login />,
  },
  {
    path: '/cadastro',
    element: <Cadastro />,
  },
  {
    path: '/termos',
    element: <TermsPage />,
  },
  {
    path: '/privacidade',
    element: <PrivacyPage />,
  },
  {
    path: '/assinatura',
    element: <UpgradePage />,
  },
  {
    element: <PrivateRoute />,
    children: [
      {
        element: <MainLayout />,
        children: [
          {
            path: '/',
            element: <RootRedirect />,
          },
          {
            path: '/launcher',
            element: <LauncherPage />,
          },
          {
            path: '/obras',
            element: <Obras />,
          },
          {
            path: '/obras/:id',
            element: <ProjectLayout />,
            children: [
              {
                index: true,
                element: <Navigate to="timeline" replace />
              },
              {
                path: 'timeline',
                element: <Timeline />,
              },
              {
                path: 'orcamento',
                element: <Orcamento />,
              },
              {
                path: 'cronograma',
                element: <Cronograma />,
              },
              {
                path: 'rdo',
                element: <RdoPage />,
              },
              {
                path: 'financeiro',
                element: <ObraFinanceiro />,
              },
              {
                path: 'estoque',
                element: <EstoquePage />,
              },
              {
                path: 'requisicoes',
                element: <RequisicoesPage />,
              },
            ]
          },
          {
            path: '/financeiro',
            element: <Financeiro />,
          },
          {
            path: '/estoque',
            element: <LogisticaPage />,
          },
          {
            path: '/estoque/recebimento',
            element: <RecebimentoPage />,
          },
          {
            path: '/equipamentos',
            element: <EquipamentosPage />,
          },
          {
            path: '/equipamentos/:id',
            element: <MachineDetails />,
          },
          {
            path: '/configuracoes',
            element: <SettingsPage />,
          },
          {
            path: '/tst',
            element: <TstDashboard />,
          },
          {
            path: '/pcm/dashboard',
            element: <PcmDashboardPage />,
          },
          {
            path: '/pcm/os/:id',
            element: <OsRedirect />,
          },
          {
            path: '/pcm/construtor',
            element: <PcmConstrutorPage />,
          },
          {
            path: '/master',
            element: <MasterDashboard />,
          },
          {
            path: '/master/cargos',
            element: <GlobalRolesPage />,
          },
          {
            path: '/master/checklists',
            element: <GlobalChecklistsPage />,
          },
          {
            path: '/master/nrs',
            element: <GlobalNrsPage />,
          },
          {
            path: '/master/panico',
            element: <GlobalPanicPage />,
          },
          {
            path: '/vouchers',
            element: <VouchersPage />,
          },
          {
            path: '/agenda',
            element: <AgendaPage />,
          },
          {
            path: '/analytics/dashboard',
            element: <IntelligenceDashboard />,
          },
        ]
      },
      {
        element: <MobileLayout />,
        children: [
          {
            path: '/pcm/operador',
            element: <PcmOperadorPage />,
          },
          {
            path: '/pcm/operador/scan',
            element: <PcmOperadorScanPage />,
          },
          {
            path: '/pcm/operador/panic',
            element: <PcmOperadorPanicPage />,
          },
          {
            path: '/pcm/operador/ativo/:id',
            element: <PcmOperadorAtivoPage />,
          },
          {
            path: '/pcm/tecnico',
            element: <Navigate to="/pcm/tecnico/home" replace />,
          },
          {
            path: '/pcm/tecnico/home',
            element: <PcmTecnicoPage />,
          },
          {
            path: '/pcm/tecnico/scan',
            element: <PcmTecnicoScanPage />,
          },
          {
            path: '/pcm/tecnico/checkin/:ativoId',
            element: <PcmTecnicoCheckinPage />,
          },
        ]
      },
    ]
  },
  {
    path: '/verify-email',
    element: <VerifyEmailPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
